"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * table actions 按钮组
 * [暂且移除]目前按钮组不做精简，传入多少按钮不管显示与否都有占位，后续依照需求优化
 * @param {object} btnConfig
 * - @param {string}  type        // 按钮行为         必填
 * - @param {string}  icon        // 按钮图标         必填|可选   需要展示为通用按钮则
 * - @param {string}  txt         // 按钮文本         可选
 * - @param {boolean} hide        // 是否隐藏         可选        默认false
 * - @param {object}  permission  // 权限-通用指令     可选        默认无
 */
var _default2 = exports.default = {
  name: 'MyButtonGroup',
  props: {
    // 按钮配置
    btnConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 显示在外面的按钮数量
    showNumber: {
      type: Number,
      default: 2
    }
  },
  computed: {
    // 计算后显示在外的btn数量，最少为0
    btnNumber: function btnNumber() {
      var num = this.showNumber;
      if (num && num > 0) {
        return num;
      } else {
        return 0;
      }
    },
    /** 过滤隐藏的按钮 */filterBtns: function filterBtns() {
      return this.btnConfig.filter(function (i) {
        return !i.hide;
      });
    },
    /** 通用展示按钮组 */normalBtns: function normalBtns() {
      var btns = [].concat(this.filterBtns).slice(0, this.btnNumber);
      return btns.filter(function (i) {
        return !i.hide;
      });
    },
    /** drop展示按钮组 */otherBtns: function otherBtns() {
      var arr = [].concat(this.filterBtns);
      var btns = arr.length > this.btnNumber ? arr.slice(this.btnNumber) : [];
      return btns.filter(function (i) {
        return !i.hide;
      });
    }
  },
  methods: {
    /** 点击事件传递 */handleClick: function handleClick(type) {
      this.$emit('handle', type);
    }
  }
};